import React from 'react';
import { VSLSection3 } from '../components/VSLSection3';
export function LandingPage3() {
  return <main className="min-h-screen bg-navy font-sans text-cream selection:bg-terracotta/30 selection:text-navy" data-id="element-265">
      <VSLSection3 data-id="element-266" />
    </main>;
}